<template>
  <div class="project-app"> 
    <My-new-nav ref="header"></My-new-nav>
      <div class="project-info">
        <div class="project-item">
          <div class="product-img"><img class="img1" src="../../../assets/image/product/app/project.png" alt="领医未来"></div>
          <div class='flexColFirCen'>
            <div class="project-name margin-top-45">领医未来</div>
            <div class="product-description">「领医未来」APP帮助医生进行互联网个人形象打造及学科化专业团队建设，进行知识传播和个人学习提升，同时对患者进行全生命周期管理，通过全场景平台业务助力医生阳光化收益。</div>
          </div>
        </div>
        <div class="project-item bg-gray">
          <ecn-title title="构建学科数字化协同管理平台"></ecn-title>
          <div class="model-item flexColFirCen">
            <div class="product-img"><img class="img2345" src="../../../assets/image/product/app/model1.png" alt="学科化专家团队建设"></div>
            <div class='flexColCen2'>
              <div class="project-name">学科化专家团队建设</div>
              <div class="product-description">组建学科化医疗团队，提供更加专业的诊疗服务；开展专科联盟化发展模式，促进学术交流和转诊互信。</div>
            </div>
          </div>
        </div>
        <div class="project-item">
          <div class="model-item flexColFirCen">
            <div class="product-img"><img class="img2345" src="../../../assets/image/product/app/model2.png" alt="全生命周期患者管理"></div>
            <div class='flexColCen2'>
              <div class="project-name">全生命周期患者管理</div>
              <div class="product-description">构建患者管理团队，分类管理患者并进行随访和教育，促进患者粘性，完成医生与患者的诊后关系建立和管理。</div>
            </div>
          </div>
        </div>
        <div class="project-item bg-gray">
          <div class="model-item flexColFirCen">
            <div class="product-img"><img class="img2345" src="../../../assets/image/product/app/model3.png" alt="全场景助力阳光化收益"></div>
            <div class='flexColCen2'>
              <div class="project-name">全场景助力阳光化收益</div>
              <div class="product-description">全场景平台业务可自主定价，多任务模式可自主选择；平台帮助医生提供证据链，获得税后收益，放心安心省心。</div>
            </div>
          </div>
        </div>
        <div class="project-item">
          <div class="model-item flexColFirCen">
            <div class="product-img"><img class="img2345" src="../../../assets/image/product/app/model4.png" alt="教学研一体化服务"></div>
            <div class='flexColCen2'>
              <div class="project-name">教学研一体化服务</div>
              <div class="product-description">资讯文章、会议直播等多形式内容帮助医生进行知识传播、内容学习和学术研究，助力医护人员成长。</div>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
export default {
    name:'project-app-mobile',
    data(){
        return{
            
        }
    },
    mounted(){
       
    },
    methods: {
       
    } 
}
</script>

<style lang="scss" scoped>
  .project-app{
    // font-family: SourceHanSansCN-Regular;
    padding-top: 120px;
    div{
      box-sizing: border-box;
    }
    .margin-top-45{
      margin-top: 45px;
    }
    .project-item{
      width: 100%;
      padding: 120px 36px;
      &:first-child{
        padding-top: 0;
      }
    }
    .project-name{
      font-family: YouSheBiaoTiHei;
      color: #212121;
      line-height: 90px;
      margin-bottom: 33px;
      font-size: 90px;
    }
    .product-description{
      font-weight: 400;
      font-size: 42px;
      color: #212121;
      // font-family: PingFangSC-Regular, PingFang SC;
      line-height: 72px;
      text-align: justify;
    }
    .model-item{
      .project-name{
        font-size: 54px;
        line-height: 54px;
      }
    }
    .flexColFirCen{
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .flexColCen2{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    .product-img{
      display: flex;
      justify-content: center;
      width: 100%;
      img{
        display: block;
      }
      .img1{
        width: 78.46%;
        max-width: 798px;
        margin: 60px 0;
      }
      .img2345{
        width: 74.92%;
        max-width: 762px;
        margin-bottom: 60px;
      }
    }
    .ecn-title ::v-deep {
      margin-bottom: 120px;
      .title{
        font-size: 54px;
        line-height: 54px;
        font-family: SourceHanSansCN-Bold, SourceHanSansCN;
        color: #333;
        letter-spacing: 3px;
      }
      .line{
        width: 84px;
        height: 18px;
        margin-top: 24px;
      }
    }
    .bg-gray{
      background-color: #F9F9FD;
    }
  }
</style>